module.exports = __webpack_public_path__ + "media/images/meeting/ic_date-bce00531bc77e1923352782c19c33c96.svg";